/**
 * Parker
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const StayPaymentStatus = {
    Due: 'Due',
    Paid: 'Paid',
    CoveredByRight: 'CoveredByRight',
    NothingToPay: 'NothingToPay'
} as const;
export type StayPaymentStatus = typeof StayPaymentStatus[keyof typeof StayPaymentStatus];

